import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router } from '@angular/router';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { SetModuleRatingDialogController } from 'dialog/set-module-rating-dialog/set-module-rating-dialog.controller';
import { SetModuleRatingDialogData } from 'dialog/set-module-rating-dialog/set-module-rating-dialog.data';
import { SetModuleRatingDialogStore } from 'dialog/set-module-rating-dialog/set-module-rating-dialog.store';
import { IModule } from 'module/module';

@Component({
	selector: 'spr-set-module-rating-dialog',
	templateUrl: './set-module-rating-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [SetModuleRatingDialogStore, SetModuleRatingDialogController],
})
export class SetModuleRatingDialogComponent {
	constructor(
		private _router: Router,
		private _config: DynamicDialogConfig,
		private _dialogRef: DynamicDialogRef,
		public controller: SetModuleRatingDialogController
	) {
		const data: SetModuleRatingDialogData = _config.data;
		controller.setData(data.coacheeId, data.moduleId);
	}

	public onModuleClick(orgModule: IModule, userId: string): void {
		this._router
			.navigate([orgModule.linkRoot, orgModule.id, 'user', userId])
			.then(() => this._dialogRef.close());
	}
}
